// extracted by mini-css-extract-plugin
module.exports = {"button":"skins-large-button-23b930cf","buttonLoading":"skins-large-buttonLoading-c2119eba"};